import './App.css';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import { Breadcrumb, Button, Layout } from "antd"
import LocaleSwitch from '@components/LocaleSwitch';
import themeConfig from "@resources/themeConfig.json"
import Logo from "@extension/Logo";
import { useCallback, useMemo } from 'react';
import { checkContrast } from '@tools/colorContrastCheck';
import { useTranslation } from 'react-i18next';

const routes: {url:string, Component: any}[] = [
    // {
    //     url: `${process.env.PUBLIC_URL}/download/:id`,
    //     Component: DownloadDocument
    // },
    // {
    //     url: `${process.env.PUBLIC_URL}/login/:email`,
    //     Component: ClientLogin
    // },
    // {
    //     url: `${process.env.PUBLIC_URL}/confirm-login/:id`,
    //     Component: ClientLoginConfirm
    // },
    // {
    //     url: `${process.env.PUBLIC_URL}/terms`,
    //     Component: LegalTermsAndConditions
    // },
    // {
    //     url: `${process.env.PUBLIC_URL}/privacy`,
    //     Component: LegalPrivacy
    // },
    // {
    //     url: `${process.env.PUBLIC_URL}/help`,
    //     Component: Help
    // }
]

export const pageWithoutLogin = () => {
    const href = window.location.href

    return routes.some(({ url }) => {
        const paramSplitUrl = url?.split(":")
        if (paramSplitUrl.length > 1) {
            return href.indexOf(paramSplitUrl[0]) !== -1
        }
        return new RegExp(paramSplitUrl[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&' + "$")).test(href)
    })
}

function App() {
    const {t} = useTranslation();
    const hasContrast = checkContrast(themeConfig.theme.primaryColor, "#111a2e")

    const onHomeClick = useCallback(() => {
        window.location.href = process.env.PUBLIC_URL
    }, [])

    const items = useMemo(() => {
        let splitUrl = window.location.href.split("/")
        const last = splitUrl.pop()
        const nextToLast = splitUrl.pop()
        let name = t(`menu:${last}.title`)
        if (name === `${last}.title`) {
            name = t(`menu:${nextToLast}.title`)
        }

        return [{ title: <span style={{color: "white" }}>{name}</span> }]
    }, [routes, hasContrast])

    return <BrowserRouter>
        <Layout >
            <Layout.Header className={`mainBreadcrumb`} style={{ backgroundColor: themeConfig.theme.primaryColor, left: 0 }}>
                <Logo styles={{ cursor: "pointer", backgroundColor: "white", borderRadius: "50%", padding: 4, display: "flex", justifyContent: "stretch" }} onClick={onHomeClick} />
                <Breadcrumb style={{ alignSelf: "center", flex: "0 0 auto", color: "white" }} className={`big${!hasContrast ? " negative" : ""}`} items={items} />
                <div style={{ flex: "1 1 auto" }} />
                <LocaleSwitch />
            </Layout.Header>
            <Routes>
                {routes.map(({ url, Component }, index) => <Route key={index} path={url} element={<Component />} />)}
            </Routes>

        </Layout>
    </BrowserRouter>;
}

export default App;
